module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-manage"
  }, [_c('banner', {
    attrs: {
      "clazz": "supplier-manage-banner",
      "url": "supplier"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('gongyingshang-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section1"
  }, [_c('div', {
    staticClass: "clearfix section1-content"
  }, [_c('img', {
    staticClass: "section1-img",
    attrs: {
      "src": require("../../assets/img/supplier/1section.png"),
      "alt": "供应商管理"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-misc"
  }, [_c('h1', {
    staticClass: "misc-title"
  }, [_vm._v("供应商管理")]), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("我们的供应商管理模块为您提供了一系列功能，使您能够提高供应商管理效率。通过供应商准入评审，对不同品类供应商多策略管控，引入征信信息，对供应商进行风险前置监控。绩效模块跟踪每个供应商绩效表现，助您实时掌控供应商动态。")]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-button",
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('gongyingshang-chanpin-yuyue')
      }
    }
  }, [_vm._v("预约演示\n          "), _c('img', {
    attrs: {
      "src": require("../../assets/img/bidding/icon_demo.svg"),
      "alt": "预约演示"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("360度洞察供应商")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "section2-detial"
  }, [_vm._v("供应商管理模块，对供应商信息，绩效和关系的全面功能。通过直观且易于使用的供应商操作台，")]), _vm._v(" "), _c('p', {
    staticClass: "section2-detial"
  }, [_vm._v(" 您的供应商可随时检视自身绩效，获知业务改善点，您可以360度全面了解供应商绩效表现，增强业务掌控力。")]), _vm._v(" "), _c('div', {
    staticClass: "section2-main"
  }, [_c('div', {
    staticClass: "section2-choose"
  }, [_c('ul', {
    staticClass: "section2-ul clearfix"
  }, _vm._l((_vm.mainData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "section2-li fl"
    }, [_c('div', {
      staticClass: "detail"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      staticClass: "detail-img",
      attrs: {
        "alt": "360度洞察供应商"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "detail-title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section3"
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section3-main"
  }, [_c('custom-swiper')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section4"
  }, [_c('div', {
    staticClass: "section4-content"
  }, [_c('h1', {
    staticClass: "section4-title"
  }, [_vm._v("通过追求供应商管理改进实现的三大目标 :")]), _vm._v(" "), _c('div', {
    staticClass: "section4-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-main"
  }, [_c('div', {
    staticClass: "section4-choose"
  }, [_c('ul', {
    staticClass: "section4-ul clearfix"
  }, _vm._l((_vm.targetData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "section4-li fl"
    }, [_c('div', {
      staticClass: "detail"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      staticClass: "detail-img",
      attrs: {
        "alt": "通过追求供应商管理改进实现的三大目标"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section5"
  }, [_c('div', {
    staticClass: "section5-content"
  }, [_c('h1', {
    staticClass: "section5-title"
  }, [_vm._v("客户案例")]), _vm._v(" "), _c('div', {
    staticClass: "section5-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section5-main"
  }, [_c('ul', {
    staticClass: "main-list clearfix"
  }, _vm._l((_vm.caseData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "detail-content fl"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.gongy_logo),
        expression: "$global.globalPath + item.gongy_logo"
      }],
      attrs: {
        "alt": "客户案例"
      }
    })])
  }), 0), _vm._v(" "), _c('p', {
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("咨询案例详情 >")])])])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-manage-section6"
  }, [_c('div', {
    staticClass: "section6-content"
  }, [_c('h1', {
    staticClass: "section6-title"
  }, [_vm._v("客户感言")]), _vm._v(" "), _c('speech-swiper', {
    attrs: {
      "mark": 0
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section3-head"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("您用供应商管理系统能做什么？")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a99211c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/supplier.vue
// module id = 415
// module chunks = 12